import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import * as sodium from 'libsodium-wrappers';
import { BEACON_VERSION } from '../../constants';
import { decryptCryptoboxPayload, encryptCryptoboxPayload } from '../../utils/crypto';
import { generateGUID } from '../../utils/generate-uuid';
import { CommunicationClient } from './CommunicationClient';
/**
 * @internalapi
 *
 *
 */

export var MessageBasedClient = /*#__PURE__*/function (_CommunicationClient) {
  _inherits(MessageBasedClient, _CommunicationClient);

  var _super = _createSuper(MessageBasedClient);

  function MessageBasedClient(name, keyPair) {
    var _this;

    _classCallCheck(this, MessageBasedClient);

    _this = _super.call(this, keyPair);
    _this.name = name;
    /**
     * The listeners that will be notified of new messages
     */

    _this.activeListeners = new Map();

    _this.init().catch(console.error);

    return _this;
  }
  /**
   * start the client and make sure all dependencies are ready
   */


  _createClass(MessageBasedClient, [{
    key: "start",
    value: function start() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return sodium.ready;

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    }
    /**
     * Get the pairing request information. This will be shared with the peer during the connection setup
     */

  }, {
    key: "getPairingRequestInfo",
    value: function getPairingRequestInfo() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return generateGUID();

              case 2:
                _context2.t0 = _context2.sent;
                _context2.t1 = this.name;
                _context2.t2 = BEACON_VERSION;
                _context2.next = 7;
                return this.getPublicKey();

              case 7:
                _context2.t3 = _context2.sent;
                return _context2.abrupt("return", {
                  id: _context2.t0,
                  type: 'postmessage-pairing-request',
                  name: _context2.t1,
                  version: _context2.t2,
                  publicKey: _context2.t3
                });

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
    /**
     * Get the pairing response information. This will be shared with the peer during the connection setup
     */

  }, {
    key: "getPairingResponseInfo",
    value: function getPairingResponseInfo(request) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.t0 = request.id;
                _context3.t1 = this.name;
                _context3.t2 = BEACON_VERSION;
                _context3.next = 5;
                return this.getPublicKey();

              case 5:
                _context3.t3 = _context3.sent;
                return _context3.abrupt("return", {
                  id: _context3.t0,
                  type: 'postmessage-pairing-response',
                  name: _context3.t1,
                  version: _context3.t2,
                  publicKey: _context3.t3
                });

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
    /**
     * Unsubscribe from encrypted messages from a specific peer
     *
     * @param senderPublicKey
     */

  }, {
    key: "unsubscribeFromEncryptedMessage",
    value: function unsubscribeFromEncryptedMessage(senderPublicKey) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var listener;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                listener = this.activeListeners.get(senderPublicKey);

                if (listener) {
                  _context4.next = 3;
                  break;
                }

                return _context4.abrupt("return");

              case 3:
                this.activeListeners.delete(senderPublicKey);

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
    /**
     * Unsubscribe from all encrypted messages
     */

  }, {
    key: "unsubscribeFromEncryptedMessages",
    value: function unsubscribeFromEncryptedMessages() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                this.activeListeners.clear();

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
    }
    /**
     * Decrypt a message from a specific peer
     *
     * @param senderPublicKey
     * @param payload
     */

  }, {
    key: "decryptMessage",
    value: function decryptMessage(senderPublicKey, payload) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var _yield$this$createCry, sharedRx, hexPayload;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.createCryptoBoxServer(senderPublicKey, this.keyPair.privateKey);

              case 2:
                _yield$this$createCry = _context6.sent;
                sharedRx = _yield$this$createCry.sharedRx;
                hexPayload = Buffer.from(payload, 'hex');

                if (!(hexPayload.length >= sodium.crypto_secretbox_NONCEBYTES + sodium.crypto_secretbox_MACBYTES)) {
                  _context6.next = 14;
                  break;
                }

                _context6.prev = 6;
                _context6.next = 9;
                return decryptCryptoboxPayload(hexPayload, sharedRx);

              case 9:
                return _context6.abrupt("return", _context6.sent);

              case 12:
                _context6.prev = 12;
                _context6.t0 = _context6["catch"](6);

              case 14:
                throw new Error('Could not decrypt message');

              case 15:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[6, 12]]);
      }));
    }
    /**
     * Encrypt a message for a specific publicKey (receiver)
     *
     * @param recipientPublicKey
     * @param message
     */

  }, {
    key: "encryptMessage",
    value: function encryptMessage(recipientPublicKey, message) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var _yield$this$createCry2, sharedTx;

        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.createCryptoBoxClient(recipientPublicKey, this.keyPair.privateKey);

              case 2:
                _yield$this$createCry2 = _context7.sent;
                sharedTx = _yield$this$createCry2.sharedTx;
                return _context7.abrupt("return", encryptCryptoboxPayload(message, sharedTx));

              case 5:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));
    }
  }]);

  return MessageBasedClient;
}(CommunicationClient);